export const initTracking = ($rowEl) => {
    const code = $rowEl.data('code');
    $rowEl.find('.js-track-save').on('click', () => {
        logEngagementWithDetails(window.location.href, 'shopping bag', 'Save For Later', code);
    });
    $rowEl.find('.js-track-favorite').on('click', () => {
        logEngagementWithDetails(window.location.href, 'shopping bag', 'Move To Favorites', code);
    });
    $rowEl.find('.js-track-remove').on('click', () => {
        logEngagementWithDetails(window.location.href, 'shopping bag', 'Remove', code);
    });
    $rowEl.find('.js-track-edit').on('click', () => {
        logEngagementWithDetails(window.location.href, 'shopping bag', 'Edit', code);
    });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/shoppingbag/tracking.js